import compose from 'recompose/compose';
import { connect } from 'react-redux';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import { CAMPAIGN_TYPE } from '../constants';

const withRenderOnPromotion = compose(
  connect(state => ({
    campaignType: state.engagement.campaign.type,
  })),
  branch(
    props => props.campaignType === CAMPAIGN_TYPE.update,
    renderNothing
  ),
);

export default withRenderOnPromotion;
